import { AutoComplete, Spin } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ReactComponent as CloseModalIcon } from '../../assets/svg/hide.svg';
import { ReactComponent as SearchIconSvg } from '../../assets/svg/search.svg';
import { Note } from '../../helbest';
import { API } from '../../request/api';
import { ProductItem } from '../../views/components';

const SearchProducts = ({ isModalVisible, setIsModalVisible }) => {
  const store = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [search_text, set_search_text] = useState('');
  const [result, set_result] = useState(null);

  const search_request = (search_text2) => {
    if (search_text2.length >= 3) {
      setIsLoading(true);
      API.get
        .search(store.Login.city_id, search_text2)
        .then((Response) => {
          if (Response.success) {
            setIsLoading(false);
            set_result(Response.data);
          }
          return Response;
        })
        .catch(() => {
          setIsLoading(false);
          Note.error('مشکل در ارتباط با سرور');
        });
    } else {
      Note.warning('حداقل ۳ کاراکتر الزامی است.');
    }
  };

  const _handleKeyDown = (e) => {
    if (e.target.value.length >= 3) {
      if (e.key === 'Enter') {
        search_request(e.target.value);
      }
    } else if (e.key === 'Enter') {
      Note.warning('لطفا نام محصول مورد نظر را وارد نمایید');
    }
  };

  return (
    <div className="search-modal" style={{ bottom: isModalVisible ? '0' : '-100%' }}>
      <div className="close-parent">
        <div
          className="close-icon-parent"
          onClick={() => {
            setIsModalVisible(false);
            set_search_text('');
            set_result([]);
          }}>
          <CloseModalIcon className="close-modal-icon" />
        </div>
        <div className="search-container">
          <AutoComplete
            className="search-input"
            onKeyDown={_handleKeyDown}
            onSearch={(value) => set_search_text(value)}
            onSelect={(value) => {
              set_search_text(value);
              search_request(value);
            }}
            placeholder="جستجوی محصول"
            value={search_text}
          />

          <div className="search-box" onClick={() => search_request(search_text)}>
            <SearchIconSvg className="button-search" />
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="text-center" style={{ 'margin-top': '50px' }}>
          <Spin className="red mt-2" size="large" />
        </div>
      ) : null}

      <div className="page-category-product-container">
        {result !== null ? (
          <>
            {result?.map((res, i) => (
              <React.Fragment key={i}>
                <ProductItem key={i} data={res} id={res.id} />
              </React.Fragment>
            ))}
            {result.length === 0 ? (
              <div className="text-center" style={{ 'margin-top': '30px', width: '100%' }}>
                <span>محصولی یافت نشد</span>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default SearchProducts;
